import { normalizeValue } from './ValueNormalizer';

export const TractorFuelType = [
  'Diesel',
  'Gasoline',
  'BioDiesel',
  'Natural Gas',
  'Other',
] as const;

export const normalizeTractorFuelType = (
  fuelType?: string | null,
): string | undefined => {
  return normalizeValue(TractorFuelType, fuelType);
};
